class FormPrivacyScroll {
  constructor(el) {
    this.el = el;
    if (document.querySelectorAll("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const boxes = document.querySelectorAll("." + this.el);

    boxes.forEach((box) => {
      this.setup(box);
    });
  }

  setup(box) {
    if (box.dataset.privacyScrollReady === "1") {
      return;
    }
    box.dataset.privacyScrollReady = "1";

    const viewport = this.ensureViewport(box);
    const { bar, track, thumb } = this.ensureScrollbar(box);

    const state = {
      dragging: false,
      startY: 0,
      startScrollTop: 0,
    };

    const update = () => {
      const scrollHeight = viewport.scrollHeight;
      const clientHeight = viewport.clientHeight;
      const maxScroll = scrollHeight - clientHeight;
      const trackHeight = track.clientHeight;

      if (maxScroll <= 0 || trackHeight <= 0) {
        bar.hidden = true;
        return;
      }

      bar.hidden = false;

      const thumbHeight = Math.max(
        (clientHeight / scrollHeight) * trackHeight,
        24
      );
      const maxThumbTop = trackHeight - thumbHeight;
      const thumbTop =
        maxScroll > 0
          ? (viewport.scrollTop / maxScroll) * maxThumbTop
          : 0;

      thumb.style.height = `${thumbHeight}px`;
      thumb.style.transform = `translateY(${thumbTop}px)`;
    };

    viewport.addEventListener("scroll", update, { passive: true });

    thumb.addEventListener("pointerdown", (e) => {
      e.preventDefault();
      state.dragging = true;
      state.startY = e.clientY;
      state.startScrollTop = viewport.scrollTop;
      thumb.setPointerCapture(e.pointerId);
      document.body.style.userSelect = "none";
    });

    thumb.addEventListener("pointermove", (e) => {
      if (!state.dragging) {
        return;
      }

      const scrollHeight = viewport.scrollHeight;
      const clientHeight = viewport.clientHeight;
      const maxScroll = scrollHeight - clientHeight;
      const trackHeight = track.clientHeight;
      const thumbHeight = thumb.offsetHeight;
      const maxThumbTop = trackHeight - thumbHeight;

      if (maxScroll <= 0 || maxThumbTop <= 0) {
        return;
      }

      const deltaY = e.clientY - state.startY;
      const scrollDelta = (deltaY / maxThumbTop) * maxScroll;
      viewport.scrollTop = state.startScrollTop + scrollDelta;
    });

    const endDrag = (e) => {
      if (!state.dragging) {
        return;
      }
      state.dragging = false;
      if (thumb.hasPointerCapture(e.pointerId)) {
        thumb.releasePointerCapture(e.pointerId);
      }
      document.body.style.userSelect = "";
    };

    thumb.addEventListener("pointerup", endDrag);
    thumb.addEventListener("pointercancel", endDrag);

    track.addEventListener("pointerdown", (e) => {
      if (e.target === thumb) {
        return;
      }

      const scrollHeight = viewport.scrollHeight;
      const clientHeight = viewport.clientHeight;
      const maxScroll = scrollHeight - clientHeight;
      const trackHeight = track.clientHeight;
      const thumbHeight = thumb.offsetHeight;
      const maxThumbTop = Math.max(trackHeight - thumbHeight, 1);
      const rect = track.getBoundingClientRect();
      const clickY = e.clientY - rect.top - thumbHeight / 2;
      const ratio = Math.min(Math.max(clickY / maxThumbTop, 0), 1);

      viewport.scrollTop = ratio * maxScroll;
      update();
    });

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(update);
      ro.observe(viewport);
      ro.observe(box);
    }

    window.addEventListener("resize", update);
    update();
    requestAnimationFrame(update);
  }

  ensureViewport(box) {
    let viewport = box.querySelector(".c-form-privacy__viewport");
    if (viewport) {
      return viewport;
    }

    viewport = document.createElement("div");
    viewport.className = "c-form-privacy__viewport";

    while (box.firstChild) {
      viewport.appendChild(box.firstChild);
    }

    box.appendChild(viewport);
    return viewport;
  }

  ensureScrollbar(box) {
    let bar = box.querySelector(".c-form-privacy__scrollbar");

    if (!bar) {
      bar = document.createElement("div");
      bar.className = "c-form-privacy__scrollbar";
      bar.setAttribute("aria-hidden", "true");
      bar.innerHTML =
        '<div class="c-form-privacy__scrollbar-track"></div><div class="c-form-privacy__scrollbar-thumb"></div>';
      box.appendChild(bar);
    }

    let track = bar.querySelector(".c-form-privacy__scrollbar-track");
    let thumb = bar.querySelector(".c-form-privacy__scrollbar-thumb");

    if (!track) {
      track = document.createElement("div");
      track.className = "c-form-privacy__scrollbar-track";
      bar.prepend(track);
    }

    if (!thumb) {
      thumb = document.createElement("div");
      thumb.className = "c-form-privacy__scrollbar-thumb";
      bar.appendChild(thumb);
    }

    return { bar, track, thumb };
  }
}
